import styled from "styled-components";

export const StyledHome = styled.div`
  padding: 5px;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex: 1;
  height: calc(100vh - 157px);
`;
